(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('AnalyticsHelper', AnalyticsHelper);

  function AnalyticsHelper($stateParams, BrandReports, StandardReports, GaUtil, Auth, LookAndFeel, DateUtil, Filters) {

    var filterEvents = {
      "Date Range": combinationSelectionEvent(["startDate", "endDate"]),
      "Detail Level": singleSelectionEvent("detailLevel"),
      "Continent": multipleSelectionEvent("continent", function () {
        return Filters.getRegion(0);
      }),
      "Country": multipleSelectionEvent("country", function () {
        return Filters.getRegion(1);
      }),
      "UI Locale": multipleSelectionEvent("uiLocale", function () {
        return Filters.getRegion(2);
      }),
      "Device Type": multipleSelectionEvent("deviceType", function () {
        return Filters.getDeviceTypes();
      }),
      "Addressable": singleSelectionEvent("addressable"),
      "Hierarchy": combinationSelectionEvent(["department", "category", "classification"])
    };

    return {
      sendPageChangeEvent: sendPageChangeEvent,
      sendLoginEvent: sendLoginEvent,
      setUserIdDimension: setUserIdDimension,
      sendViewChangeEvent: sendViewChangeEvent,
      sendDateRangeChangeEvent: sendDateRangeChangeEvent,
      sendStoreSelectionChangeEvent: sendStoreSelectionChangeEvent,
      sendDataDownloadEvent: sendDataDownloadEvent,
      sendAnalyticsFilterChangeEvent: sendAnalyticsFilterChangeEvent
    };

    function sendPageChangeEvent(fromState, toState) {
      eventCategory().then(function (category) {
        if (toState.data && (toState.name !== fromState.name)) {
          GaUtil.setGaDimension('path', (toState.data.path) ? location.pathname + toState.data.path : location.pathname);
          GaUtil.setGaDimension('title', toState.data.title);
          if (toState.data && toState.data.title) {
            GaUtil.sendGaEvent(category, 'Report View', toState.data.title);
          }
          GaUtil.sendGaPageView();
        }
      });
    }

    function sendLoginEvent() {
      eventCategory().then(function (category) {
        var eventAction = LookAndFeel.isAnalytics() ? 'Analytics Login' : 'Insight Login';
        var user = Auth.getUser();
        if (user) {
          GaUtil.sendGaEvent(category, eventAction, user.userId, false);
        }
      });
    }
    
    function setUserIdDimension() {
      var user = Auth.getUser();
      if (user) {
        GaUtil.setGaDimension('dimension1', user.userId);
        GaUtil.setGaDimension('userId', user.userId);
      }
    }

    function sendViewChangeEvent(toView) {
      eventCategory().then(function (category) {
        GaUtil.sendGaEvent(category, 'Change View', toView);
      });
    }

    function sendDateRangeChangeEvent(newDateRange, presetRanges) {
      var formattedNewStartDate = DateUtil.formatToYearMonthDay(newDateRange.startDate);
      var formattedNewEndDate = DateUtil.formatToYearMonthDay(newDateRange.endDate);

      if(!_.eq(formattedNewStartDate, $stateParams.startDate) || !_.eq(formattedNewEndDate, $stateParams.endDate)) {
        var presetRange = _.find(presetRanges, function (presetRange) {
          return _.eq(DateUtil.shortMonthDate(presetRange.dateStart()), newDateRange.startDate) &&
              _.eq(DateUtil.shortMonthDate(presetRange.dateEnd()), newDateRange.endDate);
        });
        var eventLabel = presetRange ? presetRange.text : (formattedNewStartDate + "," + formattedNewEndDate);

        analyticsEventCategory().then(function (category) {
          GaUtil.sendGaEvent(category, 'Date Range Filter', eventLabel);
        })
      }
    }

    function sendStoreSelectionChangeEvent(currentSelection, newSelection) {
      if(!StandardReports.doArraysContainSameElements(currentSelection, newSelection)) {
        var eventLabel = _.join(newSelection, ",");
        analyticsEventCategory().then(function (eventCategory) {
          GaUtil.sendGaEvent(eventCategory, 'TLA Change', eventLabel);
        });
      }
    }

    function sendDataDownloadEvent(eventType, reportName) {
      analyticsEventCategory().then( function (category) {
        var eventLabel = reportName + ' Report ' + eventType;
        GaUtil.sendGaEvent(category, 'Download Report', eventLabel);
      });
    }

    function sendAnalyticsFilterChangeEvent(newFilter) {
      var eventParams = [];

      _.each(filterEvents, function (eventParamsFn, eventType) {
        var event = eventParamsFn(newFilter, eventType);
        if(event) eventParams.push(event);
      });

      analyticsEventCategory().then(function (eventCategory) {
        _.each(eventParams, function (params) {
          GaUtil.sendGaEvent(eventCategory, params.eventAction, params.eventLabel);
        });
      });
    }

    function eventCategory() {
      if(LookAndFeel.isAnalytics()) {
        return analyticsEventCategory();
      } else if(LookAndFeel.isBrandMetrics()) {
        return brandMetricsEventCategory();
      }
    }

    function analyticsEventCategory() {
      return StandardReports.findUserStores()
          .then( function (userStores) {
            var selectedStoreKeys = StandardReports.defaultSelectedStores(userStores, $stateParams.storeKey);
            return _.join(selectedStoreKeys, ",");
          });
    }

    function brandMetricsEventCategory() {
      return BrandReports.selectedBrandKey($stateParams.brandKey);
    }

    function gaEventParams(eventAction, eventLabel) {
      return {
        eventAction: eventAction,
        eventLabel: eventLabel
      };
    }

    function multipleSelectionEvent(filterValue, allValuesFn) {
      function multipleSelectionLabel(allFilters, newFilter) {
        if(_.isEmpty(newFilter) || StandardReports.doArraysContainSameElements(allFilters, newFilter)) {
          return "All";
        } else {
          return _.join(newFilter, ",");
        }
      }
      return function (newFilter, eventType) {
        if(!StandardReports.doArraysContainSameElements($stateParams[filterValue], newFilter[filterValue])) {
          var eventAction = eventType + " Filter";
          var eventLabel = multipleSelectionLabel(allValuesFn(), newFilter[filterValue]);
          return gaEventParams(eventAction, eventLabel);
        }
      }
    }

    function singleSelectionEvent(filterValue) {
      return function (newFilter, eventType) {
        if(!_.eq(newFilter[filterValue], $stateParams[filterValue])) {
          var eventAction = eventType + " Filter";
          if(!_.isUndefined(newFilter[filterValue])) {
            return gaEventParams(eventAction, newFilter[filterValue].toString());
          }
        }
      }
    }

    function combinationSelectionEvent(filterValues) {
      return function (newFilter, eventType) {
        var areFilterValuesChanged = _.some(filterValues, function (filterType) {
          return !_.eq(newFilter[filterType], $stateParams[filterType]);
        });

        if(areFilterValuesChanged) {
          var eventAction = eventType + " Filter";
          var eventLabel = _.join(_.map(filterValues, function (value) { return newFilter[value]; }), ",");
          return gaEventParams(eventAction, eventLabel);
        }
      }
    }



  }
})();